<template>
  <div>
    <span v-if="this.errors.size > 0">{{ this.errors[0] }}</span>

    <b-card :title="formTitle">
      <b-form @submit="submitMusic">

      <b-form-group
        label="Artist"
        description="The name/alias of the artist"
        label-for="music_artist"
      >
        <b-form-input id="music_artist" type="text" v-model="music.artist"></b-form-input>
      </b-form-group>

      <b-form-group
        label="Album"
        description="The name of the album"
        label-for="music_album"
      >
        <b-form-input id="music_album" type="text" v-model="music.album"></b-form-input>
      </b-form-group>

      <b-form-group
        label="Track Count"
        description="The number of tracks in the album"
        label-for="music_track_count"
      >
        <b-form-input id="music_track_count" type="number" v-model="music.track_count"></b-form-input>
      </b-form-group>

      <b-form-group
        label="Bonus Track Count"
        description="The number of bonus tracks in the album"
        label-for="music_bonus_track_count"
      >
        <b-form-input id="music_bonus_track_count" type="number" v-model="music.bonus_track_count"></b-form-input>
      </b-form-group>

      <b-form-group
        label="Release Year"
        description="The year the album was released to the public"
        label-for="music_release_year"
      >
        <b-form-input id="music_release_year" type="text" v-model="music.release_year"></b-form-input>
      </b-form-group>

      <b-form-group
        label="Notes"
        description="Anything you'd like to add that's interesting"
        label-for="music_notes"
      >
        <b-form-textarea id="music_notes" v-model="music.notes"></b-form-textarea>
      </b-form-group>

      <b-form-group
        label="Duration"
        description="How long is the album in total (seconds)"
        label-for="music_duration"
      >
        <b-form-input id="music_duration" type="text" v-model="music.duration"></b-form-input>
      </b-form-group>

      <b-button v-if="this.id === null" type="submit" variant="success">Create Music</b-button>
      <b-button v-else type="submit" variant="info">Update Music</b-button>
    </b-form>
    </b-card>


  </div>
</template>

<script>

import { MusicService } from '@/common/services/music.service';

export default {
  name: 'MusicForm',
  components: {

  },
  props: {
    id: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      music: {
        artist: '',
        album: '',
        track_count: '',
        bonus_track_count: '',
        release_year: '',
        notes: '',
        duration: '',
      },
      errors: [],
    };
  },
  created() {
    if (this.id !== null) {
      this.getMusic(this.id);
    }
  },
  methods: {
    submitMusic(event) {
      event.preventDefault();
      if (this.id === null) {
        this.createMusic();
      } else {
        this.updateMusic();
      }
    },
    getMusic(params) {
      MusicService.get(params).then((response) => {
        this.music = response.data;
      });
    },
    createMusic() {
      MusicService.create(this.music)
      .then(({ data }) => {
        this.$emit('success', data.id);
      })
      .catch((err) => { console.warn(err.response.data); this.errors = err.response.data.error; });
    },
    updateMusic() {
      MusicService.update(this.id, this.music)
        .then(({ data }) => {
          this.$emit('success', data.id);
        }).catch((err) => {
          this.errors = err.response.data.error;
        });
    }
  },
  computed: {
    formTitle() {
      return this.id === null ? "Create Music" : "Update Music"
    }
  }
};

</script>

<style lang="scss" scoped>

</style>
